import React from "react";
import EditableHTML from "@/components/EditableHTML";
import ReflectedHeading from "@/components/ReflectedHeading";

/**
 * Mirrors what /p/<slug> renders, fed by the SitePages admin form state.
 * Doesn't fetch — purely derived from the form `page` object.
 */
const SitePagePreview = ({ page = {} }) => {
  const hasHero = page.hero_title || page.title || page.hero_image_url;

  return (
    <div className="bg-slate-950 text-slate-100 min-h-[500px] pt-10" data-testid="site-page-preview">
      {/* Mini header strip */}
      <div className="px-10 py-3 border-b border-white/5 flex items-center justify-between text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-6">
        <span>ATC · Mold & Water Restoration</span>
        <span>/p/{page.slug || "your-slug"}</span>
      </div>

      {hasHero && (
        <section className="relative overflow-hidden">
          {page.hero_image_url && (
            <>
              <div
                className="absolute inset-0 bg-cover bg-center opacity-40 mix-blend-luminosity"
                style={{ backgroundImage: `url(${page.hero_image_url})` }}
                aria-hidden="true"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-slate-950/70 via-slate-950/30 to-slate-950" />
            </>
          )}
          <div className="relative max-w-5xl mx-auto px-10 py-16">
            {page.hero_eyebrow && (
              <div className="text-xs uppercase tracking-[0.22em] text-atc-green mb-5">
                {page.hero_eyebrow}
              </div>
            )}
            <ReflectedHeading
              as="h1"
              className="font-display font-black text-5xl tracking-tight leading-[0.95] chrome-gradient-text"
            >
              {page.hero_title || page.title || "Untitled page"}
            </ReflectedHeading>
            {page.hero_subtitle && (
              <p className="mt-8 text-lg text-slate-300 max-w-2xl">{page.hero_subtitle}</p>
            )}
          </div>
        </section>
      )}

      <section className="max-w-3xl mx-auto px-10 py-12">
        {!hasHero && (
          <ReflectedHeading
            as="h1"
            className="font-display font-black text-4xl tracking-tight leading-tight chrome-gradient-text mb-10"
          >
            {page.title || "Untitled page"}
          </ReflectedHeading>
        )}
        {page.content_html ? (
          <EditableHTML
            html={page.content_html}
            className="text-slate-200 text-base leading-relaxed prose-styled"
          />
        ) : (
          <p className="text-slate-500 italic text-sm">No content yet — type in the editor to see it appear here.</p>
        )}
      </section>
    </div>
  );
};

export default SitePagePreview;
